import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the HSV treatment type.
 */
export const HsvTreatment = new TreatmentType({
  id: '7',
  name: ConsultationTreatmentTypes.Hsv,
});
